// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOcrDocumentWarningDto
 */
export interface IOcrDocumentWarningDto {
    /**
     * 
     * @type {string}
     * @memberof IOcrDocumentWarningDto
     */
    type?: IOcrDocumentWarningDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IOcrDocumentWarningDto
     */
    message?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IOcrDocumentWarningDto
     */
    fields?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof IOcrDocumentWarningDto
     */
    duplicate_document_id?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof IOcrDocumentWarningDto
     */
    duplicate_claim_ids?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof IOcrDocumentWarningDto
     */
    duplicate_claim_status?: string;
}

/**
* @export
* @enum {string}
*/
export enum IOcrDocumentWarningDtoTypeEnum {
    MISSING = 'MISSING',
    WRONG_SERVICE = 'WRONG_SERVICE',
    OUT_OF_COVERAGE_DATE = 'OUT_OF_COVERAGE_DATE',
    RETAIL_OUT_OF_COVERAGE_DATE = 'RETAIL_OUT_OF_COVERAGE_DATE',
    DUPLICATE_RECEIPT = 'DUPLICATE_RECEIPT'
}


/**
 * Check if a given object implements the IOcrDocumentWarningDto interface.
 */
export function instanceOfIOcrDocumentWarningDto(value: object): value is IOcrDocumentWarningDto {
    return true;
}

export function IOcrDocumentWarningDtoFromJSON(json: any): IOcrDocumentWarningDto {
    return IOcrDocumentWarningDtoFromJSONTyped(json, false);
}

export function IOcrDocumentWarningDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrDocumentWarningDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'message': json['message'] == null ? undefined : json['message'],
        'fields': json['fields'] == null ? undefined : json['fields'],
        'duplicate_document_id': json['duplicate_document_id'] == null ? undefined : json['duplicate_document_id'],
        'duplicate_claim_ids': json['duplicate_claim_ids'] == null ? undefined : json['duplicate_claim_ids'],
        'duplicate_claim_status': json['duplicate_claim_status'] == null ? undefined : json['duplicate_claim_status'],
    };
}

export function IOcrDocumentWarningDtoToJSON(json: any): IOcrDocumentWarningDto {
    return IOcrDocumentWarningDtoToJSONTyped(json, false);
}

export function IOcrDocumentWarningDtoToJSONTyped(value?: IOcrDocumentWarningDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'message': value['message'],
        'fields': value['fields'],
        'duplicate_document_id': value['duplicate_document_id'],
        'duplicate_claim_ids': value['duplicate_claim_ids'],
        'duplicate_claim_status': value['duplicate_claim_status'],
    };
}

